import { render } from "./EFTDisclosure.vue?vue&type=template&id=732021a4"
import script from "./EFTDisclosure.vue?vue&type=script&lang=js"
export * from "./EFTDisclosure.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__